export default "__VITE_ASSET__Dm3MGraD__"